import type { TrackingEvent } from '@/tracking/tracking-manager';
import type { Experiment } from '@/types/aggregation/home';

export const AMPLITUDE_EXPOSURE_EVENT = '$exposure';

export type ExperimentExposureProps = {
    // The flag or experiment key the user encounters (experiment id)
    flag_key: string;
    variant: string;
    // The key of the experiment the user encounters.
    // The experiment key differentiates between two runs of an experiment on the same flag key.
    experiment_key?: string;
};

export const trackExperimentExposure = (props: ExperimentExposureProps): TrackingEvent => ({
    destination: 'amplitude',
    eventProps: {
        event: AMPLITUDE_EXPOSURE_EVENT,
        ...props
    }
});

const firedExposures = new Set<string>();

export const sendExposureEvent = (
    experiments: Experiment | undefined,
    flagKey: string,
    sendEvent: (events: TrackingEvent[]) => void
): void => {
    if (firedExposures.has(flagKey)) return;

    const exp = experiments?.[flagKey];
    if (!exp?.value) return;

    sendEvent([
        trackExperimentExposure({
            flag_key: flagKey,
            variant: exp.value,
            ...(exp.metadata?.experimentKey ? { experiment_key: exp.metadata.experimentKey } : {})
        })
    ]);

    firedExposures.add(flagKey);
};
